<template>
  <div class="company-introduce-background">
    <div class="company-introduce-banner">
      <div class="company-introduce-container">
        <div class="company-introduce-banner-title">公司简介</div>
      </div>

      <img class="company-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="company-introduce-container">

     <div class="company-introduce-content">
       <div class="company-introduce-content-title">
         <div class="company-introduce-content-title-text">北京龙讯旷腾科技有限公司</div>
       </div>
       <div class="company-introduce-content-info">
         <p class="company-introduce-content-info-text">“龙讯”于2015年在北京成立，公司的目标是为在材料模拟方面的科研团队提供最新的工具和技术，帮助广大科研人员解决相关的问题。</p>
         <p class="company-introduce-content-info-text">“龙讯”将高速发展的计算技术、模拟方式、数学算法注入到强大的材料模拟工具之中，从而帮助科研人员和工业研发人员去理解、设计和发现新材料。我们研发了软硬件一体化的方案，为客户提供全方位的服务和支持；同时我们也为客户提供培训、合作会议等服务，使我们的客户和“龙讯”一起成长。</p>
       </div>

       <div class="company-introduce-content-title">
         <div class="company-introduce-content-title-text">我们的团队</div>
       </div>
       <div class="company-introduce-content-info">
         <p class="company-introduce-content-info-text">“龙”之队由顶尖的材料科学家、计算机科学家和硬件工程师组成。</p>
         <p class="company-introduce-content-info-text">我们的团队成员是电子结构计算和算法研究领域的领导者，在新方法和软件工程方面有几十年的经验。这也是“龙讯”成立的愿景：将我们对电子结构计算方面的研究成果和最新的研究进展带给我们的客户，使更多的人获益！</p>
       </div>

       <div class="company-introduce-content-title">
         <div class="company-introduce-content-title-text">我们的解决方案</div>
       </div>
       <div class="company-introduce-content-info">
         <p class="company-introduce-content-info-title-text"><i class="fa fa-hand-o-right company-introduce-content-info-title-fa"></i>强大的GPU加速平面波密度泛函软件PWmat</p>
         <p class="company-introduce-content-info-text">我们对平面波密度泛函软件在GPU方面进行了深度优化，充分发挥了GPU的加速性能，无论在计算规模还是在计算速度上，都使第一性原理计算都有了质的飞越。</p>
         <p class="company-introduce-content-info-title-text"><i class="fa fa-hand-o-right company-introduce-content-info-title-fa"></i>软硬一体机，开箱即用</p>
         <p class="company-introduce-content-info-text">通过不断对硬件的测试，我们将常见的模拟计算软件Quantum Espresso、Lammps-GPU、可视化软件VESTA预装到自主研发的“MSTATION”上面，为客户提供开箱即用的解决方案，功能强大，真正做到人无我有，人有我快的体验。此外，和CPU集群相比，MSTATION具有高性价比、低功耗、低噪音等特点。</p>
         <p class="company-introduce-content-info-title-text"><i class="fa fa-hand-o-right company-introduce-content-info-title-fa"></i>完善的售后培训和技术支持</p>
         <p class="company-introduce-content-info-text">龙讯为客户提供有针对性的专业培训，保证客户在购买之后能迅速上手。有专门的客户群，为客户解答平时使用过程中遇到的各种问题，避免遇到问题无人咨询的情况，缩短客户科研周期。</p>
       </div>

     </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "companyIntroduce"
  }
</script>

<style scoped>
  .company-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .company-introduce-background{
    margin-top: 70px;
  }
  .company-introduce-banner{
    overflow:hidden;
  }
  .company-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .company-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .company-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .company-introduce-content-title{
    padding-top: 50px;
    text-align: center;
  }
  .company-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .company-introduce-content-info{
    margin-top: 50px;
  }
  .company-introduce-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .company-introduce-content-info-title-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight: bolder;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .company-introduce-content-info-title-fa{
    font-size: 22px;
    padding-right: 8px;
  }
  .company-introduce-content-university{
    width: 346px;
    display: inline-block;
  }
  .company-introduce-content-university-fa{
    font-size: 16px;
    padding-right: 8px;
  }

  @media screen and (max-width:482px) {
    .company-introduce-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .company-introduce-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .company-introduce-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .company-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .company-introduce-container{
      max-width: 1068px;
    }
  }

</style>
